import { cookie } from '../util/storage';
import { getParams } from '../util/url';
import formatPhoneNumber from '../util/formatters';

export const updatePhoneNumber = (phoneNumber, isFormatted = true) => {
  const dynamicPhoneNumbers = new Set([
    ...document.querySelectorAll('.campaign-phone-number'),
    ...document.querySelectorAll('.ifp-phone-number')
  ]);
  cookie.set('campaign_phone', phoneNumber);

  dynamicPhoneNumbers.forEach((ele) => {
    ele.innerHTML = `<a class='campaign-phone-link' href='tel:${formatPhoneNumber(phoneNumber)}'>
    ${formatPhoneNumber(phoneNumber, '-', isFormatted)}
  </a>`;
  });
};

export const getReferrerKeys = (referrerInfo) => {
  const referrerName = document.referrer;
  const lookupKeys = Object.keys(referrerInfo);
  const lookupReferrer = lookupKeys.find(element => referrerName.includes(element) === true);
  const [
    referrerCode,
    referrerValue
  ] = referrerInfo[lookupReferrer] || referrerInfo.default;

  return [referrerCode, referrerValue];
};

export const dynamicQuoteApplyURL = (campaignID) => {
  const referralData = ['421903', '421904', 'OSYIFP', '421905', '421906'];
  const domainName = location.hostname;
  const cid = 's037';
  const campaignMedium = cookie.get('campaignMedium');
  const campaignSource = cookie.get('campaignSource');
  const campaignPhone = cookie.get('campaign_phone');
  const campaignPID = cookie.get('campaignPID');
  const campaignEID = cookie.get('campaignEID');
  const addPID = campaignPID && !referralData.includes(campaignPID) ? `&PID=${campaignPID}` : '';
  const addEID = campaignEID && !referralData.includes(campaignEID) ? `&EID=${campaignEID}` : '';

  const linkList = {
    quoteSupplemental: {
      linkToFind: 'a[href*="cignasupplemental.expressenroll.com"]',
      linkParams: `cid=${cid}&campaign_id=${campaignID}`,
      linkReplace: 'https://cignasupplemental.expressenroll.com/'
    },
    quoteDental: {
      linkToFind: 'a[href*="cignaindividual.com/public/Users/ExternalConnect.aspx"], a[href*="cignaindividual.com/public/Quoting/Individual/EnterQuoteCriteria.aspx"]',
      linkParams: `link_case=quote&campaign_id=${campaignID}&call=${formatPhoneNumber(campaignPhone, '.')}${addPID}`,
      linkReplace: 'https://cignaindividual.com/public/Users/ExternalConnect.aspx'
    },
    quoteMedical: {
      linkToFind: 'a[href*="cignaindividual.com/public-ede"]',
      linkParams: `utm_source=${campaignSource}&utm_medium=${campaignMedium}&utm_campaign=${campaignID}&campaign_ID=${campaignID}&call=${formatPhoneNumber(campaignPhone, '.')}&_agent_id=cigna${addPID}${addEID}`,
      linkReplace: 'https://cignaindividual.com/public-ede/'
    },
    quoteMedHealthSherpa: {
      linkToFind: 'a[href*="cigna.healthsherpa.com"]',
      linkParams: `utm_source=${campaignSource}&utm_medium=${campaignMedium}&utm_campaign=${campaignID}&campaign_ID=${campaignID}&call=${formatPhoneNumber(campaignPhone, '.')}&_agent_id=cigna${addPID}${addEID}`,
      linkReplace: 'https://cigna.healthsherpa.com/'
    },
  };

  Object.keys(linkList).forEach((key) => {
    const matchingLinks = document.querySelectorAll(linkList[key].linkToFind);
    [].forEach.call(matchingLinks, (ele) => {
      ele.setAttribute('href', `${linkList[key].linkReplace}?${linkList[key].linkParams}`);
    });
  });

  if (domainName.match(/(campaigns.cigna.com)/gm)) {
    const campaignsLinks = ['cigna.com/individuals-families/health-wellness/', 'hiddenheroes.org/resource/cigna-national-veteran-support-line/', 'cigna.com/web/secure/consumer/coverage/eap', '/realsupport', 'cigna.com/web/secure/consumer/directory/telehealth'];
    const params = getParams(location.search);
    const paramString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    campaignsLinks.forEach((link) => {
      const linkToChange = document.querySelectorAll(`a[href*="${link}"]`);
      [].forEach.call(linkToChange, ele => ele.setAttribute('href', `${ele.href}?${paramString}`));
    });
  }
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/campaigns/campaigns.js